import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  GroupComponent,
  RadioComponent,
  RtStatefulComponent,
} from '@core/user-interface-legacy';

type DialogData = {
  candidateName: string;
};

type State = {
  deleteParsedData: boolean;
  candidateName: string;
};

@Component({
  selector: 'rt-cv-delete-dialog',
  templateUrl: './cv-delete-dialog.component.html',
  styleUrls: ['./cv-delete-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmDialogComponent, GroupComponent, RadioComponent, TranslatePipe],
})
export class CvDeleteDialogComponent
  extends RtStatefulComponent<State>
  implements DialogComponentI<DialogData, boolean>
{
  protected readonly cdRef: ChangeDetectorRef;

  public readonly ConfirmDialogVariant = ConfirmDialogVariant;

  constructor() {
    const cdRef = inject(ChangeDetectorRef);

    super(cdRef);
    this.cdRef = cdRef;

    this.createState({
      deleteParsedData: true,
      candidateName: '',
    });
  }

  public setDelete(deleteParsedData: boolean): void {
    this.setState({
      ...this.state,
      deleteParsedData,
    });
  }

  public setDialogData(data: DialogData): void {
    this.setState({
      ...this.state,
      ...data,
    });
  }
}
